// Versión optimizada con eliminación paralela y UI optimista - CORREGIDA
(function() {
  let isProcessing = false;
  let cartCache = null;
  let cacheTimestamp = 0;
  const CACHE_DURATION = 2000; // 2 segundos

  // Función para obtener carrito (con caché)
  async function getCart(forceRefresh = false) {
    const now = Date.now();
    if (!forceRefresh && cartCache && (now - cacheTimestamp) < CACHE_DURATION) {
      return cartCache;
    }
    
    const response = await fetch('/cart.js');
    cartCache = await response.json();
    cacheTimestamp = now;
    return cartCache;
  }

  // Función para eliminar add-ons en paralelo
  async function removeAddons(productGroup, cart) {
    const addonsToRemove = cart.items.filter(item => 
      item.properties && 
      item.properties._gpo_parent_product_group === productGroup
    );

    if (addonsToRemove.length === 0) return;

    // Ocultar visualmente los add-ons inmediatamente (UI optimista)
    addonsToRemove.forEach(addon => {
      const addonElement = document.querySelector(`[data-cart-item][data-id="${addon.key}"]`);
      if (addonElement) {
        addonElement.style.opacity = '0.3';
        addonElement.style.pointerEvents = 'none';
      }
    });

    try {
      // Eliminar todos en paralelo usando Promise.all
      await Promise.all(
        addonsToRemove.map(addon =>
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: addon.key,
              quantity: 0
            })
          }).then(res => {
            if (!res.ok) throw new Error(`Failed to remove ${addon.key}`);
            return res.json();
          })
        )
      );

      // Eliminar del DOM después de confirmación
      addonsToRemove.forEach(addon => {
        const addonElement = document.querySelector(`[data-cart-item][data-id="${addon.key}"]`);
        if (addonElement) {
          addonElement.remove();
        }
      });

      // Invalidar caché y actualizar carrito
      cartCache = null;
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
    } catch (error) {
      console.error('Error removing add-ons:', error);
      
      // Rollback: restaurar visibilidad si falla
      addonsToRemove.forEach(addon => {
        const addonElement = document.querySelector(`[data-cart-item][data-id="${addon.key}"]`);
        if (addonElement) {
          addonElement.style.opacity = '1';
          addonElement.style.pointerEvents = 'auto';
        }
      });
    }
  }

  // Event listener con debouncing - CORREGIDO para solo capturar botón Remove
  document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', async function(e) {
      // CAMBIO CLAVE: Solo capturar el botón Remove, no los botones de cantidad
      const removeButton = e.target.closest('.scd-item__remove');
      if (!removeButton) return;

      // Prevenir múltiples clicks simultáneos
      if (isProcessing) return;
      isProcessing = true;

      try {
        const itemKey = removeButton.getAttribute('data-id');
        const cart = await getCart();
        
        const removedItem = cart.items.find(item => item.key === itemKey);
        if (!removedItem) return;

        const productGroup = removedItem.properties?._gpo_product_group;
        
        if (productGroup) {
          await removeAddons(productGroup, cart);
        }
      } catch (error) {
        console.error('Error in cart addon remover:', error);
      } finally {
        // Liberar después de un pequeño delay
        setTimeout(() => { isProcessing = false; }, 300);
      }
    });
  });
})();

